import { useTranslation } from "react-i18next";

import { FireStage, type StagePerson } from "@/components/camp/FireStage";
import { CAST } from "./createPreviewCast";

/** The preview's cast, sat round the fire with room left for one more. */
const AT_THE_FIRE: readonly StagePerson[] = CAST.slice(0, 4).map(
  (castmate, i) => ({
    id: castmate.id,
    name: castmate.name,
    beast: castmate.animal,
    colour: castmate.colour,
    seat: [3, 9, 5, 7][i],
    speaking: i === 1,
  }),
);

/**
 * What the way in holds while no code is typed (#834): a glimpse of a fire
 * with people at it, and the line that says what a code is for — an
 * invitation pasted above shows who is at that fire before you sit down.
 *
 * Only on a wide screen, where the way in stands beside the character card and
 * would otherwise end in an empty block down to the card's foot; a phone's
 * column has no such gap to fill and no height to spare.
 */
export function JoinIdleScene() {
  const { t } = useTranslation();
  return (
    <div data-testid="entry-join-idle" className="hidden space-y-3 lg:block">
      <div
        aria-hidden="true"
        className="h-64 overflow-hidden rounded-2xl border border-border"
      >
        <FireStage
          people={AT_THE_FIRE}
          className="h-full min-h-0 rounded-none border-0"
        />
      </div>
      <p className="text-center text-sm text-muted-foreground">
        {t("entry.idleScene")}
      </p>
    </div>
  );
}
